<template>
    <span class="ath-visual-number">
        <span class="el-stencil el--t-txt" style="width: 4rem;"></span>
    </span>
</template>

<script>
export default {
    name: 'mead-number-stencil',
};
</script>

<style lang="scss" scoped>
.ath-visual-number.te-fat .el-stencil {
    height: 3.5rem;
}
</style>
